import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eb5acda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-artwork" }
const _hoisted_2 = { class: "banner-artwork__frame" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.banner.imageUrl,
        alt: `${_ctx.banner.artistName} 绘制的岛民娘`,
        loading: "lazy",
        decoding: "async",
        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("figcaption", null, "绘制：" + _toDisplayString(_ctx.banner.artistName), 1)
  ]))
}